import queryString from 'query-string';
import { useFormContext } from 'react-hook-form';

import { PreReturnAppraisal } from '../types/base';
import { useRemoteData } from './useRemoteData';

const preReturnAppraisalEndpoint = (id: string | null, query: string) =>
  `portal/api/bff/deals/${id}/pre-return-appraisal?${query}`;

export const usePreReturnAppraisal = (
  id: string | null,
  opts?: { selected_date: string }
) => {
  // if slot avaible in near by form, we use it as fallback
  const formMethods = useFormContext();
  const slot = formMethods?.getValues('slot') || undefined;

  if (slot && !opts?.selected_date) {
    if (!opts) {
      opts = { selected_date: '' };
    }
    opts.selected_date = slot;
  }

  const query = queryString.stringify(
    {
      selected_date: opts?.selected_date,
    },
    { skipNull: true }
  );

  return useRemoteData<PreReturnAppraisal>(
    id && id !== 'no-deal' ? `pre-return-appraisal/${id}/${query}` : null,
    () => preReturnAppraisalEndpoint(id, query)
  );
};
